import { gql } from "apollo-boost";

const SAVE_DMS_CONFIG = gql`
  mutation saveDmsConfig($input: SaveDmsConfig!) {
    saveDmsConfig(input: $input) {
      data
      status
      error
    }
  }
`;

export default SAVE_DMS_CONFIG;
